import React, { useEffect, useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import { Line, Space } from '../utils/utils';

import '../../theme/global.scss';
import { IInstitution, TCallbackVoid } from '../../utils/interfaces/interfaces';
import { notify } from '../../notifications/notification';
import {
  getInstitution,
  getInstitutionByCUI,
  updateInstitution
} from '../../network/institution';
import { useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux';
import CDropdown from '../dropdown/dropdown';
import CSwitch from '../switch/switch';
import { useGetCurrentUserQuery } from '../../api';

interface IEInstitution {
  institutions: IInstitution[];
  callback: TCallbackVoid;
}

const initial_institution: IInstitution = {
  name: '',
  address: '',
  cui: '',
  orderingInstitutionId: 0,
  id: '',
  orderingInstitutionName: ''
};

const EditInstitution = (props: IEInstitution) => {
  const [institution, setInstitution] = useState(initial_institution);
  const [hasInstitution, setHasInstitution] = useState(false);
  const [chosenInstitution, setChosenInstitution] =
    useState(initial_institution);

  // const user = useAppSelector((state: RootState) => state.session.user);
  const { data: user } = useGetCurrentUserQuery();

  useEffect(() => {
    updateInitialInstitution();
    // eslint-disable-next-line
  }, [props.institutions]);

  const updateInitialInstitution = () => {
    if (user && user.institutionId) {
      getInstitution(user.institutionId).then(({ data }) => {
        setInstitution(data);

        if (data.orderingInstitutionId) {
          const query =
            props.institutions &&
            (props.institutions.find(
              (institution: IInstitution) =>
                institution.id === data.orderingInstitutionId
            )! as IInstitution) &&
            (props.institutions.find(
              (institution: IInstitution) =>
                institution.id === data.orderingInstitutionId
            )! as IInstitution);

          setChosenInstitution(query);
          setHasInstitution(true);
        }
      });
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    // setEditing(true);
    setInstitution(form => ({ ...form, [name]: value }));
  };

  const handleInstitution = (institutionChosen: any) => {
    // setEditing(true);
    if (institutionChosen) {
      if (institution.id === institutionChosen.id) {
        notify('Nu puteti alege propria institutie.', 'info');
      } else
        setInstitution(form => ({
          ...form,
          orderingInstitutionId: institutionChosen.id
        }));
    } else {
      setInstitution(form => ({
        ...form,
        orderingInstitutionId: null
      }));
    }
  };

  const handleSave = (e: React.MouseEvent) => {
    e.preventDefault();

    if (chosenInstitution.id === institution.orderingInstitutionId) {
      notify('Nu puteti alege aceeasi institutie.', 'info');
      return;
    }

    if (institution.id === institution.orderingInstitutionId) {
      notify('Nu puteti alege propria institutie.', 'info');
    } else
      updateInstitution(user?.institutionId ?? 0, { ...institution }).then(
        () => {
          notify('Ati modificat cu succes institutia', 'success');
          updateInitialInstitution();
          setInstitution(form => ({
            ...form,
            orderingInstitutionId: null
          }));
          props.callback();
        }
      );
  };

  return (
    <form>
      <p className='body-dark bold'>Editare date instituție</p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />
      <CInput
        label='Nume'
        type='text'
        id='name'
        placeholder='Nume instituție'
        name='name'
        value={institution.name}
        onChange={handleChange}
        required
      />
      <CInput
        label='Adresă'
        type='text'
        id='address'
        placeholder='Adresă instituție'
        name='address'
        value={institution.address}
        onChange={handleChange}
        required
      />
      <CInput
        label='CUI'
        type='text'
        id='cui'
        placeholder='CUI instituție'
        name='cui'
        value={institution.cui}
        onChange={handleChange}
        required
      />
      <CSwitch
        value={hasInstitution}
        label={'Doriți să alegeți o instituție ordonatoare?'}
        onChecked={() => setHasInstitution(!hasInstitution)}
      />
      {hasInstitution && (
        <CDropdown
          label='Instituție ordonatoare'
          placeholder='Căutați o instituție dupa CUI'
          onChange={handleInstitution}
          visibleKey={'name'}
          currentOption={chosenInstitution}
          fetchCall={getInstitutionByCUI}
        />
      )}
      {/* <CInput
            label='Alte informații'
            type='textarea'
            id='other'
            placeholder='alte informații'
            name='other'
            required
          /> */}
      <Space vertical={20} />

      <CButton label='Salvează' type='submit' onClick={handleSave} />
    </form>
  );
};

export default EditInstitution;
